import { render } from "./PsNotificationBox.vue?vue&type=template&id=40c760da"
import script from "./PsNotificationBox.vue?vue&type=script&lang=js"
export * from "./PsNotificationBox.vue?vue&type=script&lang=js"

import "./PsNotificationBox.vue?vue&type=style&index=0&id=40c760da&lang=css"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__